import React, { useContext, useState, useRef, useLayoutEffect } from 'react';
import { TechnologyContext } from 'context/TechnologyContext';
import { 
  BetweenVerticalStart, Car, CircleX, FileStack, FoldHorizontal, 
  GitBranchPlus, Info, SquaresUnite, Waypoints, ZoomIn, PlusSquare, 
  Lock,
  MailsIcon
} from 'lucide-react'; // Dodałem PlusSquare dla nowej ikonki zadania
import { useGant } from './useGant';
import { updateAddPrzerwaGant } from 'actions/updateAddPrzerwaGant';
import { updateDeletePrzerwaGant } from 'actions/updateDeletePrzerwaGant';
import { date_bez_time } from 'actions/date_bez_time';
import { date_time } from 'actions/date_time'; // NOWE: Import do formatowania daty w nagłówku menu
import { dropStageScalPrzerwy } from './DragDrop/dropStageScalPrzerwy';
import { dropStageZacisnijKolejkeGold } from './DragDrop/dropStageZacisnijKolejkeGold';
import { dropStageDodajPrzerweGold } from './DragDrop/dropStageDodajPrzerweGold';
import { skasujPrzerweGant } from './DragDrop/skasujPrzerweGant';
import { zablokujZadanie } from './DragDrop/zablokujZadanie';
import { ustawPrzyczytane } from './DragDrop/ustawPrzyczytane';
import { AppContext } from 'context/AppContext';

// Wspólne style dla przycisków menu
const buttonStyle = {
  width: "100%",
  textAlign: "left",
  background: "transparent",
  border: "none",
  padding: "8px 12px",
  display: "flex",
  alignItems: "center",
};

const GanttContextMenu = ({ setModalGrupyOpen, contextMenu, onClose, handleCenterOnStage, minDate, setShowWindowInfoPrzerwa }) => {
  const { fechparametryTechnologii } = useContext(TechnologyContext);
  const { refreshGantAll, generujPolaczenia, refreshGantZakonczone } = useGant();
    const {procesory} = useContext(AppContext);

  const menuRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState({ x: 0, y: 0 });

  // Obliczanie poprawnej pozycji menu przed wyrenderowaniem na ekranie
  useLayoutEffect(() => {
    if (!contextMenu || !menuRef.current) return;

    const { x, y } = contextMenu;
    const { offsetWidth: menuWidth, offsetHeight: menuHeight } = menuRef.current;
    const { innerWidth: windowWidth, innerHeight: windowHeight } = window;

    const margin = 10;

    let newX = x;
    let newY = y;

    if (x + menuWidth > windowWidth - margin) {
      newX = windowWidth - menuWidth - margin;
    }

    if (y + menuHeight > windowHeight - margin) {
      newY = windowHeight - menuHeight - margin;
    }

    newX = Math.max(margin, newX);
    newY = Math.max(margin, newY);

    setAdjustedPosition({ x: newX, y: newY });
  }, [contextMenu]);

  if (!contextMenu) return null;

  // NOWE: Destrukturyzacja rozszerzona o nowe zmienne z kliknięcia w puste miejsce
  const { stage, isFreeSpace, processorId, clickedDate } = contextMenu;
  
  // Zabezpieczenie: isBreak sprawdzamy tylko jeśli mamy obiekt 'stage'
  const isBreak = stage && stage.typ_grupy !== 2;

  // 1. Definicje akcji dla procesów (typ_grupy == 2)
  const processMenuItems = stage ? [
        {
      label: "Zaciśnij kolejkę",
      icon: <FoldHorizontal size={20} style={{ marginRight: "15px", color: "yellowgreen" }} />,
      onClick: () => dropStageZacisnijKolejkeGold(stage.global_id,stage.proces_nazwa_id, refreshGantAll),
    },
    
    {
      label: "Dodaj przerwę",
      icon: <BetweenVerticalStart size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "yellowgreen" }} />,
      onClick: () => updateAddPrzerwaGant(stage.global_id, 480, refreshGantAll, stage.proces_nazwa_id),
      textColor: "#aaaaaa",
    },
    {
      label: "Arkusze",
      icon: <FileStack size={20} style={{ marginRight: "15px" }} />,
      disabled: stage.proces_nazwa_id === 6,
      onClick: () => {
        setModalGrupyOpen(true);
        fechparametryTechnologii(stage.zamowienie_id, stage.technologia_id);
      },
    },
    {
      label: "Zoom x 0.25",
      icon: <ZoomIn size={20} style={{ marginRight: "15px" }} />,
      onClick: () => handleCenterOnStage(stage, 0.25),
    },
    {
      label: "Zoom x 1.0",
      icon: <ZoomIn size={20} style={{ marginRight: "15px" }} />,
      onClick: () => handleCenterOnStage(stage, 1.0),
    },
    {
      label: "Zoom x 2.0",
      icon: <ZoomIn size={20} style={{ marginRight: "15px" }} />,
      onClick: () => handleCenterOnStage(stage, 2.0),
    },
    {
      label: "Odkryj oddane",
      icon: <Car size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "orange" }} />,
      onClick: () => refreshGantZakonczone(stage.procesor_id, date_bez_time(minDate)),
    },
    {
      label: "Wygeneruj połączenia",
      icon: <GitBranchPlus size={20} style={{ marginRight: "15px", color: "yellowgreen" }} />,
      onClick: () => generujPolaczenia(stage.technologia_id),
    },
        {
      label: stage.nowa==1 ? "Oznacz jako przeczytane" :"Oznacz jako nieprzeczytane",
      icon: <MailsIcon size={20} style={{ marginRight: "15px", marginBottom: "5px", color: stage.nowa==1? "lightblue" :"grey", }} />,
      onClick: () => ustawPrzyczytane(stage.global_id, stage.nowa==1 ? 0:1, stage.proces_nazwa_id, refreshGantAll),
    },
{
      label: stage.zablokowany ? "Odblokuj położenie" :"Zablokuj położenie",
      icon: <Lock size={20} style={{ marginRight: "15px", marginBottom: "5px", color: stage.zablokowany ? "orange" :"grey", }} />,
      onClick: () => zablokujZadanie(stage.global_id, stage.zablokowany ? 0:1, stage.proces_nazwa_id, refreshGantAll),
    },

  ] : [];

  // 2. Definicje akcji dla istniejącej przerwy
  const breakMenuItems = stage ? [
    {
      label: "Info",
      icon: <Info size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "lightblue" }} />,
      onClick: () => setShowWindowInfoPrzerwa(true),
    },
    // {
    //   label: "Dodaj przerwę",
    //   icon: <BetweenVerticalStart size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "yellowgreen" }} />,
    //   onClick: () => updateAddPrzerwaGant(stage.global_id, 480, refreshGantAll, stage.proces_nazwa_id),
    // },
     {
      label: "Zaciśnij kolejkę",
      icon: <FoldHorizontal size={20} style={{ marginRight: "15px", color: "yellowgreen" }} />,
      onClick: () => dropStageZacisnijKolejkeGold(stage.global_id,stage.proces_nazwa_id,refreshGantAll),
    },
    {
      label: "Skasuj przerwę",
      icon: <CircleX size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "red" }} />,
      onClick: () => skasujPrzerweGant(stage.global_id, stage.proces_nazwa_id,refreshGantAll),
    },
    // {
    //   label: "Scal przerwę",
    //   icon: <SquaresUnite size={20} style={{ marginRight: "15px", marginBottom: "5px", color: "orange" }} />,
    //   onClick: () => dropStageScalPrzerwy(stage.global_id, stage.proces_nazwa_id, refreshGantAll),
    // },
        {
      label: stage.zablokowany ? "Odblokuj położenie" :"Zablokuj położenie",
      icon: <Lock size={20} style={{ marginRight: "15px", marginBottom: "5px", color: stage.zablokowany ? "orange" :"grey", }} />,
      onClick: () => zablokujZadanie(stage.global_id, stage.zablokowany ? 0:1, stage.proces_nazwa_id, refreshGantAll),
    },
  ] : [];

  // NOWE: 3. Definicje akcji dla PUSTEGO MIEJSCA
  const freeSpaceMenuItems = [
    // {
    //   label: "Dodaj nowe zadanie",
    //   icon: <PlusSquare size={20} style={{ marginRight: "15px", color: "#4d9aff" }} />,
    //   onClick: () => {
    //     console.log("Wywołaj funkcję dodawania zadania", processorId, clickedDate);
    //     // TUTAJ dodaj akcję dodawania zadania w danym czasie
    //     // np. setModalNoweZadanieOpen(true);
    //   },
    // },
    {
      label: "Wstaw przerwę tutaj",
      icon: <BetweenVerticalStart size={20} style={{ marginRight: "15px", color: "yellowgreen" }} />,
      onClick: () => {

        dropStageDodajPrzerweGold(processorId,date_time(clickedDate),480,1,refreshGantAll,procesory)
        // console.log("Wywołaj funkcję dodawania przerwy", processorId, date_time(clickedDate) );
        // TUTAJ dodaj akcję dodawania przerwy ze startem od `clickedDate`
      },
    }
  ];

  // NOWE: Wybór odpowiedniej listy w zależności od tego, w co kliknięto
  let currentMenuItems = [];
  if (isFreeSpace) {
    currentMenuItems = freeSpaceMenuItems;
  } else if (isBreak) {
    currentMenuItems = breakMenuItems;
  } else {
    currentMenuItems = processMenuItems;
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 999,
          background: "transparent",
        }}
        onClick={onClose}
        onContextMenu={(e) => {
          e.preventDefault();
          onClose();
        }}
      />

      <div
        ref={menuRef}
        style={{
          position: "fixed",
          top: adjustedPosition.y,
          left: adjustedPosition.x,
          background: "#2b2b2b",
          color: "#ffffff",
          border: "1px solid #444",
          borderRadius: "6px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
          zIndex: 1000,
          padding: "6px 0",
          minWidth: "160px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: "10px 22px",
            fontSize: "12px",
            borderBottom: "1px solid #444",
            color: "#aaa",
          }}
        >
          {/* NOWE: Wyświetlanie nagłówka w zależności od kontekstu */}
          {isFreeSpace ? (
            <>Oś czasu: <strong style={{color: '#fff'}}>{clickedDate ? date_time(clickedDate) : ''}</strong></>
          ) : !isBreak && stage ? (
            <>
              {stage.nr}_{stage.rok?.substring(2, 4)} {stage.firma_nazwa} {stage.tytul}
            </>
          ) : (
            "Przerwa"
          )}
        </div>

        {currentMenuItems.map((item, index) => {
          const isDisabled = item.disabled;
          return (
            <button
              key={index}
              disabled={isDisabled}
              style={{
                ...buttonStyle,
                color: isDisabled ? '#aaaaaa42' : (item.textColor || '#aaaaaa'),
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
              onMouseEnter={(e) => {
                if (!isDisabled) e.currentTarget.style.background = "#3a3a3a";
              }}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              onClick={() => {
                if (!isDisabled) {
                  item.onClick();
                  onClose();
                }
              }}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default GanttContextMenu;